import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
/**
 * Represents the styles of the variants.
 *
 * Note that background and border color should always be provided to make the
 * presentation work correctly.
 */
export const variantConfig = {
    textualInbound: {
        background: colors.neutral['000'],
        borderColor: colors.neutral['000'],
    },
    textualOutbound: {
        background: colors.neutral[100],
        borderColor: colors.neutral[100],
    },
    audio: {
        background: colors.neutral['000'],
        borderColor: colors.neutral[200],
    },
    internalNote: {
        background: colors.orange[100],
        borderColor: colors.orange[200],
    },
};
/**
 * Represents the component for rendering a conversation message based event,
 * such as internal message, textual message or audio message.
 */
export const ConversationMessageEventBox = ({ className, children, variant, }) => {
    return (_jsx(Box, Object.assign({}, variantConfig[variant], { className: className, padding: "300", borderWidth: "100", borderRadius: "100" }, { children: children })));
};
